/**
 * Achievement screen with category filters
 */

import { ALL_ACHIEVEMENTS } from '../game/data/achievements.js';
import { t } from '../i18n/index.js';
import { getState, getViewState, setViewState, onRender, setInnerHTML } from './renderer.js';

const CATEGORY_KEYS: { key: string; label: string }[] = [
  { key: 'all', label: 'ach_filter_all' },
  { key: 'tap', label: 'ach_filter_tap' },
  { key: 'resource', label: 'ach_filter_resource' },
  { key: 'producer', label: 'ach_filter_producer' },
  { key: 'prestige', label: 'ach_filter_prestige' },
  { key: 'time', label: 'ach_filter_time' },
  { key: 'special', label: 'ach_filter_special' },
  { key: 'docs', label: 'ach_filter_ad' },
  { key: 'combo', label: 'ach_filter_combo' },
  { key: 'conquest', label: 'ach_filter_conquest' },
];


export function initAchievementScreen() {
  onRender(renderAchievementScreen);
}

function renderAchievementScreen() {
  if (getViewState().currentTab !== 'achievement') return;

  const container = document.getElementById('screen-content');
  if (!container) return;

  const state = getState();
  const vs = getViewState();
  const filter = vs.achFilter;

  // Filter achievements
  const filtered = filter === 'all'
    ? ALL_ACHIEVEMENTS
    : ALL_ACHIEVEMENTS.filter(a => a.category === filter);

  const totalUnlocked = ALL_ACHIEVEMENTS.filter(a => state.achievements[a.id]?.unlocked).length;

  // Build filter buttons
  const filterHtml = CATEGORY_KEYS.map(ck =>
    `<button class="ach-filter-btn ${vs.achFilter === ck.key ? 'active' : ''}" data-filter="${ck.key}">${t(ck.label)}</button>`
  ).join('');

  // Build achievement list
  let listHtml = '';
  for (const ach of filtered) {
    const unlocked = state.achievements[ach.id]?.unlocked ?? false;
    listHtml += `
      <div class="ach-card ${unlocked ? 'unlocked' : ''}">
        <div class="ach-icon">${ach.icon}</div>
        <div class="ach-info">
          <div class="ach-name">${t('ach_' + ach.id.toLowerCase())}</div>
          <div class="ach-reward-text">${t('ach_' + ach.id.toLowerCase() + '_reward')}</div>
        </div>
      </div>
    `;
  }

  const achHtml = `
    <div class="achievement-screen">
      <div style="text-align:center;margin-bottom:8px;color:var(--text-dim);font-size:12px;">
        ${t('ach_title')}: ${totalUnlocked} / ${ALL_ACHIEVEMENTS.length}
      </div>
      <div class="ach-filters">${filterHtml}</div>
      <div class="ach-list">${listHtml}</div>
    </div>
  `;

  if (setInnerHTML(container, achHtml)) {
    // Filter handlers (only rebind when DOM changed)
    container.querySelectorAll('[data-filter]').forEach(btn => {
      btn.addEventListener('click', () => {
        setViewState({ achFilter: (btn as HTMLElement).dataset.filter! });
      });
    });
  }
}
